import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { I18n } from 'common/i18n';
import FilterPropType from 'common/propTypes/FilterPropType';

import ColumnDropdown from '../ColumnDropdown';
import { setColumn } from '../../../actions/editor';
import { MeasureFilterBar } from '../FilterBar';
import { isColumnUsableWithMeasureArgument } from 'common/performance_measures/measureCalculator';
import measurePropType from 'common/performance_measures/propTypes/measurePropType';

export class Average extends Component {
  renderFilterBar() {
    const { calculationNotConfigured, calculationFilters, displayableFilterableColumns, measure } =
      this.props;

    // displayableFilterableColumns is not available until a data source has been selected _and_ its metadata
    // has loaded, but it is required to load the FilterBar.
    if (_.isEmpty(displayableFilterableColumns)) {
      return;
    }

    const filterableColumns = _.filter(displayableFilterableColumns, (column) => {
      // TODO: make valueColumn a constant
      return isColumnUsableWithMeasureArgument(column, measure, 'valueColumn');
    });

    return (
      <div className="metric-config">
        <MeasureFilterBar
          addFilterDisabled={calculationNotConfigured || _.isEmpty(filterableColumns)}
          filters={calculationFilters}
        />
      </div>
    );
  }

  // Left-hand pane with average-specific options.
  renderConfigPane() {
    const {
      calculationNotConfigured,
      columnFieldName,
      displayableFilterableColumns,
      measure,
      onSelectColumn,
    } = this.props;

    const dropdownOptions = {
      columnFieldName,
      calculationNotConfigured,
      displayableFilterableColumns,
      id: 'average-column',
      measure,
      measureArgument: 'valueColumn',
      onSelectColumn,
    };

    return (
      <div className="metric-config">
        <h5>
          {I18n.t(
            'shared.measures_editor.measure.edit_modal.calculation.types.average.column_selector_title',
          )}
        </h5>
        <div className="column-dropdown">
          <ColumnDropdown {...dropdownOptions} />
        </div>
        {this.renderFilterBar()}
      </div>
    );
  }

  renderDefinitionText() {
    const scope = 'shared.measures_editor.measure.edit_modal.calculation.types.average';
    return (
      <div className="metric-definition-text">
        <h5>{I18n.t('help_title', { scope })}</h5>
        {I18n.t('help_body', { scope })}
      </div>
    );
  }

  render() {
    return (
      <div className="metric-container">
        {this.renderConfigPane()}
        {this.renderDefinitionText()}
      </div>
    );
  }
}

Average.defaultProps = {
  calculationNotConfigured: false,
};

Average.propTypes = {
  calculationFilters: PropTypes.arrayOf(FilterPropType),
  columnFieldName: PropTypes.string,
  displayableFilterableColumns: PropTypes.arrayOf(
    PropTypes.shape({
      renderTypeName: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      fieldName: PropTypes.string.isRequired,
    }),
  ),
  calculationNotConfigured: PropTypes.bool,
  measure: measurePropType.isRequired,
  onSelectColumn: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const columnFieldName = _.get(state, 'editor.measure.metricConfig.arguments.column');
  const displayableFilterableColumns = _.get(state, 'editor.displayableFilterableColumns');
  const calculationFilters = _.get(state, 'editor.measure.metricConfig.arguments.calculationFilters');

  return {
    calculationFilters,
    columnFieldName,
    displayableFilterableColumns,
    measure: state.editor.measure,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onSelectColumn: setColumn,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Average);
